<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler"></swb-query-sort-area>

        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="saveInfoForm(null)">
                    <span>新增</span>
                </button>
            </div>
        </div>

        <div class="table-layout">
            <el-table :data="dataList" border :height="theTableHeight" style="width: 100%">
                <el-table-column prop="name" label="名称" align="left"></el-table-column>
                <el-table-column prop="creatorName" label="创建人" align="left" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center" width="150"></el-table-column>
                <el-table-column label="排序" width="70" align="center">
                    <template slot-scope="rows">
                        <i class="icon iconfont icon-arrow-top swb-btn swb-btn-link" @click="moveData(rows.row.id, true)"></i>
                        <i class="icon iconfont icon-arrow-bottom swb-btn swb-btn-link" @click="moveData(rows.row.id, false)"></i>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="操作" align="left" width="300">
                    <template slot-scope="rows">
                        <div class="swb-btn swb-btn-link" @click="viewDetail(rows.row.id)">查看详情</div>
                        <div class="swb-btn swb-btn-link" @click="exportData(rows.row.id)">导出excel</div>
                        <div class="swb-btn swb-btn-link" @click="saveInfoForm(rows.row.id)">修改</div>
                        <div class="swb-btn swb-btn-link" @click="deleteData(rows.row.id)">删除</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pagination-layout">
            <el-pagination background v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'

    import shopDevcApi from '../../api/shopDevc'

    import SwbShopDeviceList from '../devc/ShopDeviceList'
    Vue.regist(SwbShopDeviceList);

    import SwbDevcInfoFormSave from './DevcInfoFormSave'
    Vue.regist(SwbDevcInfoFormSave);

    import SwbDevcInfoFormDetail from './DevcInfoFormDetail'
    Vue.regist(SwbDevcInfoFormDetail);

    let mockConfigData = {
        "queryFields": [{
            "type": "Text",
            "valueType": "String",
            "label": "名称",
            "code": "name",
            "basic": true
        }, {
            "type": "Text",
            "valueType": "String",
            "label": "创建人",
            "code": "creatorName",
            "basic": true
        }, {
            "type": "Date2",
            "valueType": "String",
            "label": "创建时间",
            "code": "createTime",
            "basic": true
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-devc-info-form-list',
        desc: '设备信息单列表',
        props: {
            devcId: {
                type: Number,
                deafult: null
            },
            devcNo: {
                type: String,
                deafult: null
            }
        },
        data: function () {
            return {
                // 分页信息
                theTableHeight: 500,
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                // 过滤信息
                queryConfig: mockConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                dataList: [],
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.getDataList();
        },
        methods: {
            checkActionPerm: function (action) {
                return checkUserActionPerm(SwbShopDeviceList.path, action, null);
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getDataList();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            getDataList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.devcId = self.devcId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                // 调用查询接口
                shopDevcApi.getDevcInfoFormList(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.dataList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 查看详情
            viewDetail(id){
                let theDlg = Vue.$showDialog({
                    title: "设备信息单-详情",
                    width: 1300,
                    height: 800,
                    okVisible: false,
                    showCloseBtn: true,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-devc-info-form-detail :id="id" ref="swb_devc_info_form_save"></swb-devc-info-form-detail>' +
                    '</div>',
                    data: {
                        id: id
                    }
                });
            },
            // 删除
            deleteData(id){
                let self = this;
                //弹出确认框
                this.$confirm('确定删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    shopDevcApi.deleteDevcInfoForm(id, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            self.$message.success("操作成功");
                            self.getDataList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            moveData: function (id, toUp) {
                var self = this;
                let data = {};
                data.id = id;
                data.toUp = toUp;
                let theLoad = MsgBox.loading();
                shopDevcApi.doDevcInfoFormMove(data, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        self.$message.success("操作成功");
                        self.getDataList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            saveInfoForm(id){
                let self = this;
                let title = "新增";
                if(id != null) {
                    title = "修改";
                }
                let theDlg = Vue.$showDialog({
                    title: "设备信息单-" + title,
                    width: 1300,
                    height: 800,
                    okVisible: true,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-devc-info-form-save :id="id" :devcId="devcId" :devcNo="devcNo" ref="swb_devc_info_form_save"></swb-devc-info-form-save>' +
                    '</div>',
                    data: {
                        id: id,
                        devcId: self.devcId,
                        devcNo: self.devcNo
                    },
                    okClicked: function () {
                        let resultData = this.$refs.swb_devc_info_form_save.getDlgResult() || {};
                        if(resultData.type == 'info') {
                            let devcInfoForm = resultData.data;
                            if(id != null) {
                                let theLoading = MsgBox.loading();
                                shopDevcApi.updateDevcInfoForm(devcInfoForm, function (result) {
                                    theLoading.close();
                                    if(result.type == "info") {
                                        theDlg.close();
                                        self.$message.success("修改成功");
                                        self.getDataList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            } else {
                                let theLoading = MsgBox.loading();
                                shopDevcApi.saveDevcInfoForm(devcInfoForm, function (result) {
                                    theLoading.close();
                                    if(result.type == "info") {
                                        theDlg.close();
                                        self.$message.success("保存成功");
                                        self.getDataList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            }
                        }
                        return false;
                    }
                });
            },
            exportData(id){
                // 导出盘点明细
                let url = "/api/shop/devc/info/form/export/do";
                url = Utils.makeUrl(url, {id: id});
                Utils.setPageUrl(getAppUrl(url), '_blank');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/DevcInfoFormList.vue